import { render, staticRenderFns } from "./MoraDialog.vue?vue&type=template&id=d9f4d1ac&scoped=true&"
import script from "./MoraDialog.vue?vue&type=script&lang=js&"
export * from "./MoraDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoraDialog.vue?vue&type=style&index=0&id=d9f4d1ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f4d1ac",
  null
  
)

export default component.exports